
import React, {  useState } from 'react';
import { View, Text, TouchableOpacity, Image, ActivityIndicator } from 'react-native';
import {  CreateResponsiveStyle, DEVICE_SIZES, maxSize} from "rn-responsive-styles";
import CImage from './CImage';
import { logout } from "./../api/apiManager";
import AsyncStorageFunc from '../utilities/asyncStorage';
import RootNavigation from "../utilities/RootNavigation";
import { useLogin } from '../context/loginProvider';
import { CONSTANTS } from "../utilities/Dimensions";


// create a component
const TabHeader = (props) => {
    const styles = useStyles();
    const [loading, setLoading] = useState(false);
    const { isLoggedIn, setIsLoggedIn } = useLogin();
    const IMG_DATA = global.userProfileImg  ||""

    const userLogout = params => {
        setLoading(true)
        let req = {
            userId: global.userId
        }
        logout(req).then((res) => {
            setTimeout(() => {
                setLoading(false)
                AsyncStorageFunc.deleteData('TOKEN').then((tokenRes) => {
                    console.log(tokenRes, 'tokenRes3')
                    setIsLoggedIn(false)
                    RootNavigation.navigate("Login")
                });
            }, 1000);

        }).catch()
    }
   
    return (
        <View style={styles.container}>
          <View style={styles.subContainer}>
                <View style={{ flexDirection: "row" }}>
                   <View style={styles.defaultProfilePicBg}>
                        {IMG_DATA == "" || IMG_DATA == null ? (
                            <CImage.DefaultProfilePic></CImage.DefaultProfilePic>
                        ) : (
                            <Image
                                source={{ uri: `data:image/png;base64,${IMG_DATA}` }}
                                style={{
                                    height: "100%",
                                    width: "100%",
                                    borderRadius: 100,
                                    marginRight: 10,
                                }}
                            />
                        )}
                    </View>
                    <View style={{ alignItems: "flex-start", justifyContent: "center" }}>
                        <Text style={styles.globalName}> {global.userFullName} </Text>
                        <TouchableOpacity onPress={() => userLogout()}>
                            <Text
                                style={{
                                    fontFamily: "Inter",
                                    fontSize:  15,
                                    lineHeight:  22,
                                    letterSpacing: 0,
                                    textAlign: "left",
                                    color: "#ffffff",
                                    marginLeft:5
                                }}
                            >
                                {"Switch to "}
                                <Text
                                    style={{
                                        fontFamily: "Inter",
                                        fontSize:  15,
                                        lineHeight:  22,
                                        letterSpacing: 0,
                                        textAlign: "left",
                                        color: "#ffffff",
                                        textDecorationLine: "underline"
                                    }}
                                >
                                    {"other user"}
                                </Text>
                            </Text>
                        </TouchableOpacity>
                        {loading && <ActivityIndicator size={"large"} color="#707070" style={styles.spinner} />}
                    </View>
                </View>
                    <View>
                        <TouchableOpacity
                            style={{
                                marginRight: 20,
                                alignItems: "center",
                                justifyContent: "center",
                                width: 149,
                                height: 31,
                                borderStyle: "solid",
                                borderWidth: 2,
                                borderColor: "#ffffff",
                                borderRadius: 20,
                                flexDirection: "row",
                            }}
                            onPress={() => {
                                RootNavigation.navigate("Profile", { screen: "Add Vehicles", })
                                global.activeScreen = "Profile"
                            }}
                        >
                            <CImage.AddVehicleWhite></CImage.AddVehicleWhite>
                            <Text
                                style={{
                                    fontFamily: "Inter",
                                    fontSize:  CONSTANTS.PROFILE_TEXT_WIDTH,
                                    lineHeight:  CONSTANTS.PROFILE_TEXT_WIDTH,
                                    letterSpacing: 0,
                                    textAlign: "center",
                                    color: "#ffffff",
                                }}
                            >
                                {"Add Vehicle"}
                            </Text>
                        </TouchableOpacity>
                    </View>
            </View>
      
        </View>
       
    );
};

// define your styles
const useStyles = CreateResponsiveStyle({
    container: {
        width: "100%",
        display:'none',
        backgroundColor:'#232323',
        
    },
    subContainer:{
         flexDirection: "row",
         alignItems: "center",
         justifyContent: "space-between",
         flex: 1,
         marginHorizontal: 30,
    },
    defaultProfilePicBg:
    {
        width: 60, height: 60, borderRadius: 50, marginRight: 10,marginTop:10,
    },
    globalName:{
        fontFamily: "Inter",
        fontSize: 26,
        fontWeight: "normal",
        fontStyle: "normal",
        lineHeight: 36,
        letterSpacing: 0,
        textAlign: "left",
        color: "#66625f",
        paddingTop: 15,
        paddingLeft: 10,
      },
      spinner:{
        position:'absolute',
        right:144,
        top:44,
        zIndex:999,
        width:100,
        height:30,
        backgroundColor:'transparent'
},
},
    {
        [DEVICE_SIZES.SM]: {
            
        },
        [DEVICE_SIZES.MD]: {
            container:{
                display:'flex'
            }
        },
        [maxSize(DEVICE_SIZES.XS)]: {
            

        },
    });

export default TabHeader;
